export default submission => submission.is_locked;
